<template>
  <tr>
    <td>
            <span>
                <v-select class="w-full" v-model="selected_pricelist" label="code" disabled
                          @option:selected="changePricelist($event)" :filterable="false" :options="priceListRes"
                          @search="searchPricelist">
                    <template slot="no-options">
                        Sök...
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.code + ' ' + option.description }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            {{ option.code }}
                        </div>
                    </template>
                </v-select>
            </span>
    </td>
    <td>
            <span v-if="item.price_list">
                <b-form-input
                    class="w-full"
                    name="login-email"
                    :value="item.price_list.description"
                    disabled
                    :placeholder="
                        ''
                    "
                />
            </span>
    </td>
    <td>
            <span>
                <b-form-input
                    class="w-full"
                    name="login-email"
                    v-model="item.price"
                    v-on:focusout="computeMargin"
                    :placeholder="
                        ''
                    "
                />
            </span>
    </td>
    <td>
            <span>
                <b-form-input
                    class="w-full"
                    name="login-email"
                    :value="item.from_quantity"
                    v-model="item.from_quantity"
                    disabled
                    :placeholder="
                        ''
                    "
                />
            </span>
    </td>
    <td>
            <span>
                {{ margin }}
            </span>
    </td>
    <td>
      <div class="gap-3" v-if="updating === false">
                <span class="cursor-pointer" @click="updateArticlePrice(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"/>
                    </svg>
                </span>
        <span class="cursor-pointer" @click="removeArticlePrice(item)">
                    <feather-icon icon="Trash2Icon"/>
                </span>
      </div>
      <span v-else>{{ $t('Message.loading') }}...</span>
    </td>
  </tr>
</template>

<script>
import debounce from "lodash.debounce";
import vSelect from 'vue-select';
import bus from '@/bus';


export default {
  name: "ArticlePriceRow",
  components: {vSelect},
  props: {
    itemData: {
      type: Object,
    },
    index: {
      type: Number,
    },
    article_instance: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      item: {},
      pricelist: [],
      priceListRes: [],
      margin: 0,
      updating: false,
      showPrice: false,
      selected_pricelist: "",
      article: {purchase_price: 0},
      isNotSalesPrice: false,
    }
  },
  watch: {
    'item.price': function (n, o) {
      this.computeMargin();
    }
  },
  mounted() {
    this.item = this.itemData;
    this.isNotSalesPrice = !this.item.price_list.pre_selected;
    this.selected_pricelist = this.itemData.price_list.code;
    // if (this.item.price_list !== null && this.item.price_list.pre_selected) {
    //
    // }
    this.article = this.article_instance;

    // this.getPriceList();
    this.computeMargin();
  },
  methods: {
    computeMargin() {
      let margin = this.item.price - this.article.purchase_price;
      if (!isNaN(margin)) {
        this.margin = margin;
      } else {
        this.margin = "-";
      }
    },
    searchPricelist(search, loading) {
      if (search.length) {
        loading(true);
        this.searchRemotePricelist(loading, search, this);
      }
    },
    searchRemotePricelist: debounce(function (loading, search, vm) {
      this.$useJwt.getAllRegisters(`pricelists?search=${escape(search)}`)
          .then(res => {
            this.priceListRes = res.data.results
            loading(false);
          })
          .catch(err => {
          })
    }, 350),
    changePricelist(data) {
      this.selected_pricelist = data.code;
      this.item.description = data.description;
      // if (data.pre_selected) {
      //     this.selected_pricelist = data.code;
      //     this.item.description = data.description;
      // } else {
      //     this.popupMsg(
      //         this.$t('Message.Failed'),
      //         'Only preselected are required',
      //         'AlertTriangleIcon',
      //         'danger'
      //     );
      //     this.selected_pricelist = this.itemData.price_list.code;
      // }
      //
    },
    updateArticlePrice(item) {
      this.updating = true;
      const payload = {
        article_number: item.article.article_number,
        price_list: this.selected_pricelist,
        price: item.price,
        from_quantity: this.item.from_quantity,
        id: item.id,
      };

      const mode = {URL: `/prices/${item.uuid}`, method: 'put'}

      this.$useJwt.customArticles(mode, payload)
          .then(res => {
            // bus.$emit('refetch')
            this.updating = false
            this.popupMsg(
                this.$t('Message.Success'),
                res.data[this.message],
                'CheckIcon',
                'success'
            );
          })
          .catch(err => {
            this.updating = false
            if (err.response.data && err.response.data && err.response.data.message) {
              if (err.response.data.message.ErrorInformation) {
                this.popupMsg(
                    this.$t('Message.Failed'),
                    err.response.data.message.ErrorInformation.message,
                    'AlertTriangleIcon',
                    'danger'
                );
              } else {
                this.popupMsg(
                    this.$t('Message.Failed'),
                    err.response.data.message,
                    'AlertTriangleIcon',
                    'danger'
                );
              }
            } else {
              this.popupMsg(
                  this.$t('Message.Failed'),
                  err.response.data[this.message],
                  'AlertTriangleIcon',
                  'danger'
              );
            }
          })
    },
    removeArticlePrice(item) {
      this.$emit("remove-article-price", this.itemData);
    },
  }
}
</script>

<style lang="scss" scoped>
.table th {
  padding: .3rem !important;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table tbody, td {
  padding: 5px !important;
  vertical-align: top;
  border-top: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
}
</style>